import axios from 'axios';

var token =  localStorage.getItem("vue-token");
var token_f = "Bearer "+token;
console.log(token_f)



// var token = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJhaVIzVEFma2VybGQ3MzdmTFdRc21ETk5CSjZJSTBLV2xLbVV4Z0YxZWlFIn0.eyJleHAiOjE1OTU0MjU2NzUsImlhdCI6MTU5NTQyNTM3NSwianRpIjoiMjA4ZTM0OTctMTlkMC00ZjUzLTkxMDktMzNhYzg4ZjYyODY4IiwiaXNzIjoiaHR0cDovL2R3cy1kZXYuYXJpbWFjLnh5ei9hdXRoL3JlYWxtcy9zb2Z0bG9naWMiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiNDY5ZmQyMTQtZjZmZC00OGRjLTkzYjUtOTU0NmY3MDEyZTVlIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoidXNlci1tZ3Qtc2VydmljZSIsInNlc3Npb25fc3RhdGUiOiIyMjhiZTkxMC1iOGYzLTQwZWYtOTQ0NS03OWIyOTc0NjdhMzYiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9sb2NhbGhvc3Q6ODA4MCJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsicm9sZSIsIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iLCJ1c2VyIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJlbWFpbCBwcm9maWxlIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJuaW1lc2hhIn0.RT6BuFbb5y6lRJ33a-F02fR4PA5ksCX0XX62QtS69Z82ie4Nd6nsDpmoIrzTn0skB18k-d9jeVhXvAhsZCfCW1vEfmMtDiJ7Vi27EDKPGtho4ZJiCw-wAmlppiuvI7gWlaiPnHYRx7waJ5-XvnOwY6Q0omcOHwU_tHEHfHPSiVbM1nxlJkcyYDfL9GuCEg874WIruiS8fDPs8huL-cMF4xNq5ReL4K19av55A5KOZA0ZxOzo8U0nLtI7OKvi6wkwvjoIHalvWScD5WP0D1gMqc52xjZAeFWIfCMWdx3-Ar_sW2Xkra6gHPZWDbu4eKVd1BvkZxSHXQTZ68DBcux3WA'
export const HTTP = axios.create({
  baseURL: `http://dws-dev.arimac.xyz/api/usr-mgt`,
  headers: {    
    Authorization: token_f,
    'x-client-platform':'web',
    'x-client-request-id':'55b5n3jhj3n35jh',
    'tenant':'softlogic',



  }
})